import { FileUploadOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  styled,
  CardMedia,
  CircularProgress,
} from '@mui/material';
import defaultImage from 'components/VideoCard/defaultImage.svg';
import { useState } from 'react';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const LoadingIcon = () => <CircularProgress size={14} />;

export const ThumbUpload = ({ image, onChange, loading }) => {
  const [imagePreview, setImagePreview] = useState(image || defaultImage);

  const handleChange = event => {
    const fileUploaded = event.target.files[0];
    setImagePreview(URL.createObjectURL(fileUploaded));
    onChange && onChange(fileUploaded);
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gap: 1,
      }}>
      <CardMedia
        sx={{
          width: '156px',
          height: '156px',
          position: 'relative',
          border: 'solid 1px #EAEAEA',
          alignSelf: 'center',
        }}
        image={imagePreview}
        title="thumbnail"
      />

      <Button
        variant="outlined"
        component="label"
        size="small"
        disabled={loading}
        startIcon={loading ? <LoadingIcon /> : <FileUploadOutlined />}
        sx={{
          textTransform: 'none',
          fontWeight: 'bold',
          width: '156px',
        }}>
        Alterar Thumbnail
        <VisuallyHiddenInput
          onChange={handleChange}
          type="file"
          accept="image/*"
        />
      </Button>
    </Box>
  );
};
